module.exports = __webpack_public_path__ + "static/media/SerifGoodOptimized.24f2ccc0.webp";